
export enum UserRoles {
  photographer = 'ROLE_PHOTOGRAPHER',
  admin = 'ROLE_ADMIN',
  customer = 'ROLE_CUSTOMER'
}

export enum UserStatus {
  notRegistered = 'not-registered',
  registering= 'registering',
  registered = 'registered',
}

export interface User
{
  id: number;
  email: string|null;
  firstname: string|null;
  lastname: string|null;
  slug: string;
  image: string|null;
  roles: string[];
  status: string;
  online: boolean;
  city: string|null;
  siret: string|null;
  maskedIban: string|null;
  maskedBic: string|null;
  tags: string[]|null;
  biography: string|null;
  subscriptionPlan: string|null;
  subscriptionPlanLabel: string|null;
  canGetFreeTrial: boolean|null;
  isInTrial: boolean|null;
  isActive: boolean|null;
  trialEndDate: string|null;
  instagramLinkShared: boolean|null;
  preferredLanguage: string|null;
}
